export const TOOLTIP = {
  aquiferName: 'The water bearing geological layer that the well is screened in',
  storativity:
    'The volume of water an aquifer releases from, or takes into, storage per unit surface area of a saturated confined aquifer per unit change in head',
  drawdown: 'The reduction in water level caused by the pumping of water from the well',
  maxFlowRate: 'The maximum rate that water was pumped from the well',
  kB: 'The ratio of aquitard hydraulic conductivity and saturated thickness. The inverse of hydraulic resistance',
  conductivity:
    'The volume of water that can move through a porous medium in unit time under a unit hydraulic gradient through a unit area measured perpendicular to the direction of flow',
  transmissivity:
    'The rate at which water is transmitted though a unit width of an aquifer under a unit hydraulic gradient',
  aquiferTestDrawdown: 'Preliminary measure of bore performance',
  leakage: 'The leakage through an aquitard into a semi-confined (leaky) aquifer, or vice versa',
  dataReference: 'The file name for the aquifer test data',
  parameterAccuracyId: 'The rating for the derived aquifer parameters as determined by the aquifer test reviewer',
  reportNo: 'The file name for the aquifer test report',
  testRatingId: 'The rating for the aquifer test design and setup as determined by the aquifer test reviewer',
  maxDrawdown: 'The reduction in water level caused by the pumping of water from the well',
  galleryWidth: 'Diameter of the gallery pipe or trench',
  galleryDepth: 'The deepest point of the gallery pipe or trench',
  galleryEndLongitude: 'End point of gallery pipe or trench',
  galleryStartLongitude: 'Start point of gallery pipe or trench',
  galleryEndLatitude: 'End point of gallery pipe or trench',
  galleryStartLatitude: 'Start point of gallery pipe or trench',
  galleryEndEasting: 'End point of gallery pipe or trench',
  galleryStartEasting: 'Start point of gallery pipe or trench',
  galleryEndNorthing: 'End point of gallery pipe or trench',
  galleryStartNorthing: 'Start point of gallery pipe or trench',
  galleryDirectionId: 'Direction of the gallery pipe or trench from start to end',
  maxDepthDrilled: 'The deepest point of the well installation',
  proposedMaxDepthDrilled: 'The proposed depth of well installation prior to drilling',
  actualMaxDiameter:
    'The diameter of the well installation at the wellhead. Takes values of up to 50,000 mm for pit wells, and 2,000 mm for all other types',
  proposedMaxDiameter:
    'The proposed diameter of the well installation prior to drilling. Takes values of up to 50,000 mm for pit wells, and 2,000 mm for all other types',
  measuringPointElevationNzvd2016: 'Relative to the elevation reference point',
  measuringPointLocalElevation: 'Relative to the elevation reference point',
  casingHeight: 'The distance from ground level to the top of the well casing',
  groundLevelCorrection: 'The distance from the elevation reference point to ground level',
  elevationRefPointDescription: 'The reference point at or near the well that elevation is measured to ',
  proposedLatitude: 'The proposed well latitude prior to drilling',
  proposedLongitude: 'The proposed well longitude prior to drilling',
  actualLatitude: 'The actual drilled well latitude',
  actualLongitude: 'The actual drilled well longitude',
  actualNorthing: 'The actual drilled well northing',
  actualEasting: 'The actual drilled well easting',
  proposedNorthing: 'The proposed well northing prior to drilling',
  proposedEasting: 'The proposed well easting prior to drilling',
  aquiferTypeId: 'The confinement of the water bearing geological layer that the well is screened in',
  boreConsentNo: 'The consent number that relates to the installation of the well',
  customerReferenceNo: "The customer ID from Council's customer management system",
  locationDescription: 'A description of the well location relative to other features around it ',
  measuringPointDescription: 'The reference point on the wellhead that groundwater levels are measured to ',
  measuringPointCorrection: 'The distance from the elevation reference point to groundwater level measuring point',
  measuringPointLocalDate: 'The date the elevation was established',
  measuringPointLocalMethodId: 'The method used to establish the elevation',
  measuringPointLocalSurveyBy: 'The organisation name of the survey party',
  measuringPointNzvdDate: 'The date the elevation was established',
  measuringPointNzvdMethodId: 'The method used to establish the elevation',
  measuringPointNzvdSurveyBy: 'The organisation name of the survey party',
  waterAllocationZoneId: "The area defined in Council's regional plans",
  waterManagementZoneId: "The area defined in Council's regional plans",
  decommissioningDetails: 'General information on the decommissioning process',
  decommissioningQualityId: 'Council staff have verified the well has been decommissioned',
  samplingTapLocation: 'The point from which a groundwater sample can be collected',
  wellCap: 'The cap that prevents things entering the well casing',
  inspectionDate: 'The date that a desktop or field inspection was carried out to capture the wellhead security data',
  inspectedBy: 'The person undertaking the desktop or field inspection to capture the wellhead security data',
  sealAroundWellhead:
    'The seal around the well casing below ground level. Often only determined at time of installation.',
  bungsSealed: 'The entry bungs or ports are securely sealed to prevent water or things entering the well casing',
  pumpInstallDepth: 'The depth of the intake point for an installed pump',
  wellheadCovering: 'The structure that houses the wellhead',
  coveringSecure: 'The structure that houses the wellhead is secured to prevent tampering',
  stockAccess: 'Whether stock have direct access to the wellhead',
  wellheadTopography: 'The topography of the area immediately around the wellhead ',
  wellheadHazards: 'Any hazards that are present in the area around the wellhead',
  surroundingLanduse: 'The predominant use of the land around the wellhead (within 50m)',
  drillerStratumDescription: 'Text description to describe the stratum layer',
  yield: 'The rate at which water was pumped from the well',
  testAnalysisPerson: 'The person who performed the aquifer test analysis',
  testReviewedByPerson: 'The person who reviewed the aquifer test',
  documentLinkUrl:
    'If you add a link url here, the document reference will become a clickable link that will open in a new tab. Access controls for the document should be managed by the council. By default, only council staff and drillers can see this link. Use the "Show link to public?" toggle to also display it in the public Documents tab.',
}
